import { FromToFilterType, VehicleWarningFilterType } from "@/types";

export const emptyVehicleWarningFilter: VehicleWarningFilterType = {
    isOverweight: false,
    isOverheight: false,
    isSensorAvoided: false
};

export const emptyFromToFilter: FromToFilterType<any> = {
    from: null,
    to: null
};